// Module
var code = `<model-viewer
  id="marevo_model"
  ar
  ar-modes="webxr scene-viewer quick-look"
  ar-scale="auto"
  src="public/models/empty_scene.glb"
  poster=""
  loading="eager"
  alt="Marevo_AR"
  shadow-intensity="1"
  shadow-softness="1"
  environment-image="neutral"
  stage-light-intensity="1"
  camera-orbit="-30deg auto auto"
  max-camera-orbit="auto 100deg auto"
  camera-controls
  exposure="1.0"
  auto-rotate
>
  <div id="ar-prompt">
    <img src="https://modelviewer.dev/shared-assets/icons/hand.png" />
  </div>
</model-viewer>
`;
// Exports
export default code;